import {
  AssetClientOptions,
  createAssetsHttpClient,
  getAssetClient as getAssetClientLib,
} from "@adsk/acs-assets-api-clients";
import {
  fetchWithToken as platformFetch,
  getRegion,
} from "@adsk/acs-sc-web-platform-api";

import { getEnvValue } from "../env";
import { ProjectId } from "../types";

/**
 * Browser adapter for `getAssetClient`.
 *
 * Closes over the platform `fetchWithToken`+`getRegion` and the env-resolved
 * `ASSETS_BACKEND` URL so that call sites can continue calling
 * `getAssetClient(projectId, options?)` unchanged.
 *
 * TODO(T001.4.x): once all shared-web clients are migrated, collapse into a
 * single top-level `createBrowserAssetsHttpClient()` factory.
 */
export const getAssetClient = (
  projectId: ProjectId,
  clientOptions?: AssetClientOptions
) => {
  const http = createAssetsHttpClient({
    fetch: (url, init) =>
      platformFetch(url, {
        ...init,
        headers: { region: getRegion(), ...init?.headers },
      }),
    baseUrl: getEnvValue("ASSETS_BACKEND"),
  });
  return getAssetClientLib({ http, projectId, clientOptions });
};
